/**
 * @file
 */


/* This initializes the easy Ticker jquery control.  
*  Note that images are being used for the 'playText' and 'PauseText'.  In actuality 
*  those attributes can hold html formating, text, etc.
*/
export function InitializeSpecialMessagesControl() {
   $('.ticker').easyTicker({
      direction: 'up',
      easing: 'swing',
      speed: 'medium',
      interval: 8000,
      height: 83,
      visibile: 1,
      mousePause: 0,
      controls: {
         up: '.btnUp',
         down: '.btnDown',
         toggle: '.btnToggle',
         playText: '<img src="/images/site/play.jpg" alt="Play Button" width="22" />',
         stopText: '<img src="/images/site/pause.jpg" alt="Pause Button" width="22" />'
      }
   });
};
